exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".brown-color-text {\n  color: rgba(249, 168, 37, 0.64);\n}\n\n.light-blue-text {\n  color: #0097a7;\n}\n\n.price {\n  float: left;\n  line-height: 3;\n  font-family: reserwebfont;\n  font-size: 18px;\n}\n\n.unit-label {\n  float: left;\n\n  font-size: 29px;\n}\n\n.unit-label mat-icon {\n\n  font-size: 40px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/component/price-label/price-label.component.css
// module id = 1155
// module chunks = 0